module.exports = {
      id: "twittericon-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-3da3c54197bd9bf6e26a7217bd920efb.svg#twittericon",
      toString: function () {
        return this.url;
      }
    }